const LIST_QUERY = `
  query ListAccount {
    listAccount {
      email
    }
  }
`

const CREATE_MUTATION = `
  mutation CreateAccount(
    $secret: String!,
    $accountName: String!,
    $address: String!,
    $companyName: String!,
    $website: String!,
    $phoneNumber: String!,
    $contactFirstName: String!,
    $contactLastName: String!,
    $email: String!,
    $companyLogoAddress: String!,
    $subDomain: String!,
    $maxStepupDevices: Int,
  ){
    BDCreateAccount(secret: $secret, params: {
      address: $address
      accountName: $accountName
      companyName: $companyName
      website: $website
      phoneNumber: $phoneNumber
      contactFirstName: $contactFirstName
      contactLastName: $contactLastName
      email: $email
      companyLogoAddress: $companyLogoAddress
      subDomain: $subDomain
      maxStepupDevices: $maxStepupDevices
    }) {
      user {
        username,
        firstName,
        lastName,
        email,
      }
      password
    }
  }
`
const UPDATE_MUTATION = `
  mutation UpdateEmail($email: String!) {
    updateAccount(params: {
      email: $email,
    }) {
      email
    }
  }
`

const UPDATE_FACILITY_CODE_MUTATION = `
  mutation UpdateSetting(
    $facilityCode: Int,
    ) {
    updateSettings(params: {
      facilityCode: $facilityCode
    })
  }
`

const accountQueries = {
  methods: {
    async updateFacilityCode(facilityCode, subDomain, accountInfo) {
      try {
        const _loginPayload = {
          subDomain: subDomain.toLowerCase(),
          username: accountInfo.user.username.toLowerCase(),
          password: accountInfo.password,
        }
        await this.login(_loginPayload)
        const result = await this.graphQuery(UPDATE_FACILITY_CODE_MUTATION, {
          facilityCode,
        })
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async createAccountMutation(secret, accountDetails) {
      try {
        const {facilityCode} = accountDetails
        delete accountDetails.facilityCode
        const _result = await this.graphQuery(CREATE_MUTATION, {
          secret,
          ...accountDetails,
        }, true)
        if (facilityCode > 0) {
          console.log(`Sending facility Code: ${facilityCode}`)
          await this.updateFacilityCode(
            facilityCode,
            accountDetails.subDomain,
            _result.BDCreateAccount,
          )
        }
        return _result.BDCreateAccount
      } catch (error) {
        console.log(JSON.stringify(error))
        throw new Error(error)
      }
    },
    async listAccountDetails() {
      try {
        const _result = await this.graphQuery(LIST_QUERY)
        return _result
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateEmailMutation(email) {
      try {
        const _result = await this.graphQuery(UPDATE_MUTATION, {email})
        return _result
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default accountQueries
